import {EVENTS} from '../events';

export class WoocommercePlugin {
	constructor(chat) {
		this.chat = chat;
	}

	init() {
		this.chat.on(EVENTS.WSCHAT_ON_RENDER_USER_META, () => this.get_order_summary());
	}

	get_order_summary() {
        const data = {
        	conversation_id: this.chat.conversation.id,
        	action: 'wschat_admin_wc_get_orders_summary'
        };

        jQuery.post(this.chat.options.api.endpoint, data, (res) => {
        	this.refresh_ui(res.data);
        }).fail(f => {
        	console.log(f);
        });
	}

	get_el() {
		if (this.el) {
			return this.el;
		}

		this.el = jQuery(`<div class="row mb-2 wschat_woocommerce_order_summary"></div>`);

		jQuery(document).find('.user-meta-info').append(this.el);

		this.el;
	}

	reset_ui() {
		console.log(this.get_el())
		this.get_el().html('');
	}

	refresh_ui(res) {
		this.reset_ui();

		this.el.append(OrdersSection(res.orders));

		this.el.append(CustomerValue(res.summary))
	}
}

const OrdersSection = (orders) => {
	let html = jQuery(`<div class="wschat_recent_orders">
		<div class="align-items-center d-flex flex-row justify-content-between">
			<h6 >Orders</h6>
			<a  href="#">See all>></a>
		</div>
	</div>`);

	orders.forEach(order => {
		html.append(OrderItem(order));
	});

	return html;
}

const OrderItem = order => {
	let html = `<div class="card mt-1 py-1 p-3 wschat-woocommerce-orders-info">
		<div class="row">
			<div class="col">
				<a href="#">#${order.id}</a><br />
				<p class="text-small text-muted m-0">${order.date}</p>
			</div>
			<div class="col-auto align-self-center">
				<b>${order.currency_symbol} ${order.total} ${order.currency}</b>
			</div>
		</div>
		<div class="card m-0 p-2 position-absolute py-1 shadow-sm w-100 top-0 wschat-woocommerce-orders-details" style="left: -100%">
			<div class="d-flex justify-content-between">
				<a href="#">#${order.id}</a><br />
				<span class="badge bg-success rounded-pill">${order.status}</span>
			</div>
			<div class="d-flex justify-content-between align-items-center mt-2 ">
				<ul class="list-inline m-0">
					${order.products.slice(0, 5).map(product => ProductThumbnail(product))}
				</ul>
				${order.products.length >5 ? `<span>+${order.products.length -5} more</span>`:``}
			</div>
		</div>
	</div>`;

	return html;
}

const CustomerValue = summary => {
	return `
		<div class="customer-value mt-2">
			<div class="align-items-center d-flex flex-row justify-content-between">
				<h6 class="m-0">Customer Value</h6>
			</div>
		<div class="card mt-0">
			<div class="row align-items-center">
				<div class="col-4 p-0">
					<div class="rounded-circle border border-2 border-primary p-1 text-center ratio ratio-1x1">
						<div class="d-flex align-items-center justify-content-center">
						<span>Total <br>Orders<br>${summary.total_orders}</span>
						</div>
					</div>
				</div>
				<div class="col-8">
					<table class="table table-sm table-borderless m-0 ">
						<tr>
							<td>Completed</td>
							<td>${summary.completed_orders}</td>
						</tr>
						<tr>
							<td>Returned/Cancelled</td>
							<td>${summary.cancelled_orders}</td>
						</tr>
						<tr>
							<td>Total Revenue</td>
							<td>${summary.currency_symbol + summary.total_revenue }</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		</div>
	`;
}

const ProductThumbnail = product => {
	return `
		<li class="list-inline-item m-0" style="width: 35px">
		<img src="${product.thumbnail}" class="img-thumbnail w-100" title="${product.name}" />
		</li>
	`;
}
